export default __webpack_public_path__ + "images/models/1e24b3d6535dfd7edc4c57a8a78ec512.usdz";